class StudioScroll {
  constructor() {
    $(document).ready(() => {
      this.initialize();
    });
  }

  initialize() {
    this.scroll = 0;
    this.height = 0;
    this.calculatedHeight = 0;
    this.lastScrollTop = 0;
    this.topPos = 0;
    this.studioContainer = document.querySelector('.studio .product__info');
    if(!this.studioContainer) return;
    
    this.height = this.studioContainer.offsetHeight;
    this.calculatedHeight = this.studioContainer.offsetHeight;
  }

  updateHeight(height) {
    // this.studioContainer.style.top = `${this.topPos - Number(height)}px`
    this.calculatedHeight = this.height + height;
   
    gsap.to(this.studioContainer, {
      top: this.topPos - Number(height),
      duration: 0.35,
      ease: 'Sine.easeInOut'
    })

    // this.studioContainer.style.height = `${this.calculatedHeight}px`
    gsap.to(this.studioContainer, {
      height: this.calculatedHeight,
      duration: 0.35,
      ease: 'Sine.easeInOut'
    })
  }

  onScroll(scroll) {
    if(!this.studioContainer) return;
    this.scroll = scroll;
    const top = this.studioContainer.getBoundingClientRect().y;
    const wHeight = window.innerHeight;

    this.studioContainer.style.height = `${this.calculatedHeight}px`;

    if(this.lastScrollTop > this.scroll) {
      if(this.topPos <= 0) {
        this.topPos-= this.scroll - this.lastScrollTop;
        this.studioContainer.style.top = `${this.topPos}px`
      }
      if(this.scroll < window.innerHeight) {
        this.studioContainer.classList.remove('sticky')
      }
    } else {
      if(wHeight - this.calculatedHeight > top) {
        this.topPos = wHeight - this.calculatedHeight;
        this.studioContainer.classList.add('sticky')
        this.studioContainer.style.top = `${this.topPos}px`
      }

      if(wHeight - this.calculatedHeight < top && this.studioContainer.classList.contains('sticky')) {
        if(this.topPos > wHeight - this.calculatedHeight) {
          this.topPos-= this.scroll - this.lastScrollTop;
          this.studioContainer.style.top = `${this.topPos}px`
        }
      }
    }

    this.lastScrollTop = this.scroll;
  }
}

const studioScroll = new StudioScroll();